// extracted by mini-css-extract-plugin
module.exports = {"checkout-code":"CheckoutCode-module__checkout-code___fzaR7","code":"CheckoutCode-module__code___2ZPpF","tooltip":"CheckoutCode-module__tooltip___2iRtD"};